import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function Navbar() {
  const {
    scrollY
  } = useScroll();
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    language,
    setLanguage,
    t,
    tArray
  } = useLanguage();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const links = tArray<string>('navbar.links');
  const sectionIds = ['vision', 'support', 'partner', 'faq'];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${isScrolled ? 'bg-ivory/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-126">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-127">
        <div className={`font-heading text-2xl md:text-3xl font-semibold tracking-wide cursor-pointer transition-colors duration-500 ${isScrolled ? 'text-navy' : 'text-warmWhite'}`} onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-128">
          {t('navbar.logo')}
        </div>

        <div className="hidden lg:flex items-center space-x-8" data-id="element-129">
          {links.map((item, idx) => <button key={idx} onClick={() => scrollTo(sectionIds[idx] || item.toLowerCase())} className={`text-sm tracking-widest uppercase transition-colors duration-300 hover:text-saffron ${isScrolled ? 'text-navy/70' : 'text-warmWhite/80'}`} data-id="element-130">
              {item}
            </button>)}

          <div className="flex items-center space-x-4 border-l border-current pl-4 opacity-80" data-id="element-131">
            <button onClick={() => setLanguage('en')} className={`text-xs font-semibold tracking-wider ${language === 'en' ? 'text-saffron' : isScrolled ? 'text-navy' : 'text-warmWhite'}`} data-id="element-132">
              EN
            </button>
            <span className={isScrolled ? 'text-navy/30' : 'text-warmWhite/30'} data-id="element-133">
              |
            </span>
            <button onClick={() => setLanguage('pa')} className={`text-xs font-semibold tracking-wider ${language === 'pa' ? 'text-saffron' : isScrolled ? 'text-navy' : 'text-warmWhite'}`} data-id="element-134">
              ਪੰ
            </button>
          </div>

          <button onClick={() => scrollTo('support')} className={`px-6 py-2.5 rounded-sm text-sm tracking-widest uppercase transition-all duration-300 ${isScrolled ? 'bg-navy text-ivory hover:bg-saffron hover:text-navy' : 'bg-saffron text-navy hover:bg-ivory'}`} data-id="element-135">
            {t('navbar.donateCta')}
          </button>
        </div>

        {/* Mobile menu button placeholder */}
        <div className="lg:hidden flex items-center space-x-4" data-id="element-136">
          <div className="flex items-center space-x-2 mr-2" data-id="element-137">
            <button onClick={() => setLanguage('en')} className={`text-xs font-semibold ${language === 'en' ? 'text-saffron' : isScrolled ? 'text-navy' : 'text-warmWhite'}`} data-id="element-138">
              EN
            </button>
            <span className={isScrolled ? 'text-navy/30' : 'text-warmWhite/30'} data-id="element-139">
              |
            </span>
            <button onClick={() => setLanguage('pa')} className={`text-xs font-semibold ${language === 'pa' ? 'text-saffron' : isScrolled ? 'text-navy' : 'text-warmWhite'}`} data-id="element-140">
              ਪੰ
            </button>
          </div>
          <button className={`p-2 ${isScrolled ? 'text-navy' : 'text-warmWhite'}`} data-id="element-141">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-142">
              <path d="M4 6h16M4 12h16M4 18h16" data-id="element-143" />
            </svg>
          </button>
        </div>
      </div>
    </motion.nav>;
}